export enum SortByItemKeys {
  NONE = 'none',
  PRICE_LOW_TO_HIGH = 'priceLowToHigh',
  PRICE_HIGH_TO_LOW = 'priceHighToLow',
}

const SORT_BY_ITEM_KEY_SET = new Set<string>(Object.values(SortByItemKeys));

/**
 * Reads `sort-by` from listing query params. Treats missing, empty, and invalid
 * values (e.g. the literal `"undefined"`) as {@link SortByItemKeys.NONE}.
 */
export function parseSortBySearchParam(value: string | null | undefined): SortByItemKeys {
  const trimmed = value?.trim();
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
    return SortByItemKeys.NONE;
  }
  if (SORT_BY_ITEM_KEY_SET.has(trimmed)) {
    return trimmed as SortByItemKeys;
  }
  return SortByItemKeys.NONE;
}
